/**
 * Kody urzędów skarbowych (Etap 27, ADR-0028).
 *
 * Nagłówek deklaracji elektronicznej wymaga POLA `KodUrzedu` — czterech cyfr
 * z oficjalnego wykazu, nie nazwy urzędu. Nazwa w aktach („Urząd Skarbowy
 * Warszawa-Śródmieście") nie da się zamienić na kod bez słownika, a zgadywanie
 * kończy się odrzuceniem pliku przez bramkę.
 *
 * Wykaz pochodzi wprost ze schematu Ministerstwa Finansów
 * `KodyUrzedowSkarbowychExWUS_v8-0E.xsd` (crd.gov.pl, wersja z 23.12.2021),
 * czyli z tego samego źródła, którym waliduje się deklarację. To słownik
 * wydania, nie dane firmy [D19].
 */

export interface TaxOffice {
  readonly code: string
  readonly name: string
}

export const TAX_OFFICES: readonly TaxOffice[] = [
  { code: '0202', name: 'Urząd Skarbowy w Bolesławcu' },
  { code: '0203', name: 'Urząd Skarbowy w Bystrzycy Kłodzkiej' },
  { code: '0204', name: 'Urząd Skarbowy w Dzierżoniowie' },
  { code: '0205', name: 'Urząd Skarbowy w Głogowie' },
  { code: '0206', name: 'Urząd Skarbowy w Jaworze' },
  { code: '0207', name: 'Urząd Skarbowy w Jeleniej Górze' },
  { code: '0208', name: 'Urząd Skarbowy w Kamiennej Górze' },
  { code: '0209', name: 'Urząd Skarbowy w Kłodzku' },
  { code: '0210', name: 'Urząd Skarbowy w Legnicy' },
  { code: '0211', name: 'Urząd Skarbowy w Lubaniu' },
  { code: '0212', name: 'Urząd Skarbowy w Lubinie' },
  { code: '0213', name: 'Urząd Skarbowy w Lwówku Śląskim' },
  { code: '0214', name: 'Urząd Skarbowy w Miliczu' },
  { code: '0215', name: 'Urząd Skarbowy w Nowej Rudzie' },
  { code: '0216', name: 'Urząd Skarbowy w Oleśnicy' },
  { code: '0217', name: 'Urząd Skarbowy w Oławie' },
  { code: '0218', name: 'Urząd Skarbowy w Strzelinie' },
  { code: '0219', name: 'Urząd Skarbowy w Środzie Śląskiej' },
  { code: '0220', name: 'Urząd Skarbowy w Świdnicy' },
  { code: '0221', name: 'Urząd Skarbowy w Trzebnicy' },
  { code: '0222', name: 'Urząd Skarbowy w Wałbrzychu' },
  { code: '0223', name: 'Urząd Skarbowy w Wołowie' },
  { code: '0224', name: 'Urząd Skarbowy Wrocław-Fabryczna' },
  { code: '0225', name: 'Urząd Skarbowy Wrocław-Krzyki' },
  { code: '0226', name: 'Urząd Skarbowy Wrocław-Psie Pole' },
  { code: '0227', name: 'Urząd Skarbowy Wrocław-Stare Miasto' },
  { code: '0228', name: 'Urząd Skarbowy Wrocław-Śródmieście' },
  { code: '0229', name: 'Pierwszy Urząd Skarbowy we Wrocławiu' },
  { code: '0230', name: 'Urząd Skarbowy w Ząbkowicach Śląskich' },
  { code: '0231', name: 'Urząd Skarbowy w Zgorzelcu' },
  { code: '0232', name: 'Urząd Skarbowy w Złotoryi' },
  { code: '0233', name: 'Urząd Skarbowy w Górze' },
  { code: '0234', name: 'Urząd Skarbowy w Polkowicach' },
  { code: '0402', name: 'Urząd Skarbowy w Aleksandrowie Kujawskim' },
  { code: '0403', name: 'Urząd Skarbowy w Brodnicy' },
  { code: '0404', name: 'Pierwszy Urząd Skarbowy w Bydgoszczy' },
  { code: '0405', name: 'Drugi Urząd Skarbowy w Bydgoszczy' },
  { code: '0406', name: 'Trzeci Urząd Skarbowy w Bydgoszczy' },
  { code: '0407', name: 'Urząd Skarbowy w Chełmnie' },
  { code: '0408', name: 'Urząd Skarbowy w Grudziądzu' },
  { code: '0409', name: 'Urząd Skarbowy w Inowrocławiu' },
  { code: '0410', name: 'Urząd Skarbowy w Lipnie' },
  { code: '0411', name: 'Urząd Skarbowy w Mogilnie' },
  { code: '0412', name: 'Urząd Skarbowy w Nakle nad Notecią' },
  { code: '0413', name: 'Urząd Skarbowy w Radziejowie' },
  { code: '0414', name: 'Urząd Skarbowy w Rypinie' },
  { code: '0415', name: 'Urząd Skarbowy w Świeciu' },
  { code: '0416', name: 'Pierwszy Urząd Skarbowy w Toruniu' },
  { code: '0417', name: 'Drugi Urząd Skarbowy w Toruniu' },
  { code: '0418', name: 'Urząd Skarbowy w Tucholi' },
  { code: '0419', name: 'Urząd Skarbowy w Wąbrzeźnie' },
  { code: '0420', name: 'Urząd Skarbowy we Włocławku' },
  { code: '0421', name: 'Urząd Skarbowy w Żninie' },
  { code: '0422', name: 'Urząd Skarbowy w Golubiu-Dobrzyniu' },
  { code: '0423', name: 'Urząd Skarbowy w Sępólnie Krajeńskim' },
  { code: '0602', name: 'Urząd Skarbowy w Białej Podlaskiej' },
  { code: '0603', name: 'Urząd Skarbowy w Biłgoraju' },
  { code: '0604', name: 'Urząd Skarbowy w Chełmie' },
  { code: '0605', name: 'Urząd Skarbowy w Hrubieszowie' },
  { code: '0606', name: 'Urząd Skarbowy w Janowie Lubelskim' },
  { code: '0607', name: 'Urząd Skarbowy w Krasnymstawie' },
  { code: '0608', name: 'Urząd Skarbowy w Kraśniku' },
  { code: '0609', name: 'Urząd Skarbowy w Lubartowie' },
  { code: '0610', name: 'Pierwszy Urząd Skarbowy w Lublinie' },
  { code: '0611', name: 'Drugi Urząd Skarbowy w Lublinie' },
  { code: '0612', name: 'Trzeci Urząd Skarbowy w Lublinie' },
  { code: '0613', name: 'Urząd Skarbowy w Łukowie' },
  { code: '0614', name: 'Urząd Skarbowy w Opolu Lubelskim' },
  { code: '0615', name: 'Urząd Skarbowy w Parczewie' },
  { code: '0616', name: 'Urząd Skarbowy w Puławach' },
  { code: '0617', name: 'Urząd Skarbowy w Radzyniu Podlaskim' },
  { code: '0618', name: 'Urząd Skarbowy w Tomaszowie Lubelskim' },
  { code: '0619', name: 'Urząd Skarbowy we Włodawie' },
  { code: '0620', name: 'Urząd Skarbowy w Zamościu' },
  { code: '0621', name: 'Urząd Skarbowy w Łęcznej' },
  { code: '0622', name: 'Urząd Skarbowy w Rykach' },
  { code: '0802', name: 'Urząd Skarbowy w Gorzowie Wielkopolskim' },
  { code: '0803', name: 'Urząd Skarbowy w Krośnie Odrzańskim' },
  { code: '0804', name: 'Urząd Skarbowy w Międzyrzeczu' },
  { code: '0805', name: 'Urząd Skarbowy w Nowej Soli' },
  { code: '0806', name: 'Urząd Skarbowy w Słubicach' },
  { code: '0807', name: 'Urząd Skarbowy w Świebodzinie' },
  { code: '0808', name: 'Pierwszy Urząd Skarbowy w Zielonej Górze' },
  { code: '0809', name: 'Drugi Urząd Skarbowy w Zielonej Górze' },
  { code: '0810', name: 'Urząd Skarbowy w Żaganiu' },
  { code: '0811', name: 'Urząd Skarbowy w Żarach' },
  { code: '0812', name: 'Urząd Skarbowy w Drezdenku' },
  { code: '0813', name: 'Urząd Skarbowy w Sulęcinie' },
  { code: '0814', name: 'Urząd Skarbowy we Wschowie' },
  { code: '1002', name: 'Urząd Skarbowy w Bełchatowie' },
  { code: '1003', name: 'Urząd Skarbowy w Brzezinach' },
  { code: '1004', name: 'Urząd Skarbowy w Głownie' },
  { code: '1005', name: 'Urząd Skarbowy w Kutnie' },
  { code: '1006', name: 'Urząd Skarbowy w Łasku' },
  { code: '1007', name: 'Urząd Skarbowy w Łowiczu' },
  { code: '1008', name: 'Pierwszy Urząd Skarbowy Łódź-Bałuty' },
  { code: '1009', name: 'Drugi Urząd Skarbowy Łódź-Bałuty' },
  { code: '1010', name: 'Pierwszy Urząd Skarbowy Łódź-Górna' },
  { code: '1011', name: 'Drugi Urząd Skarbowy Łódź-Górna' },
  { code: '1012', name: 'Urząd Skarbowy Łódź-Polesie' },
  { code: '1013', name: 'Urząd Skarbowy Łódź-Śródmieście' },
  { code: '1014', name: 'Urząd Skarbowy Łódź-Widzew' },
  { code: '1015', name: 'Urząd Skarbowy w Opocznie' },
  { code: '1016', name: 'Urząd Skarbowy w Pabianicach' },
  { code: '1017', name: 'Urząd Skarbowy w Piotrkowie Trybunalskim' },
  { code: '1018', name: 'Urząd Skarbowy w Poddębicach' },
  { code: '1019', name: 'Urząd Skarbowy w Radomsku' },
  { code: '1020', name: 'Urząd Skarbowy w Rawie Mazowieckiej' },
  { code: '1021', name: 'Urząd Skarbowy w Sieradzu' },
  { code: '1022', name: 'Urząd Skarbowy w Skierniewicach' },
  { code: '1023', name: 'Urząd Skarbowy w Tomaszowie Mazowieckim' },
  { code: '1024', name: 'Urząd Skarbowy w Wieluniu' },
  { code: '1025', name: 'Urząd Skarbowy w Zduńskiej Woli' },
  { code: '1026', name: 'Urząd Skarbowy w Zgierzu' },
  { code: '1027', name: 'Urząd Skarbowy w Wieruszowie' },
  { code: '1028', name: 'Urząd Skarbowy w Łęczycy' },
  { code: '1029', name: 'Urząd Skarbowy w Pajęcznie' },
  { code: '1202', name: 'Urząd Skarbowy w Bochni' },
  { code: '1203', name: 'Urząd Skarbowy w Brzesku' },
  { code: '1204', name: 'Urząd Skarbowy w Chrzanowie' },
  { code: '1205', name: 'Urząd Skarbowy w Dąbrowie Tarnowskiej' },
  { code: '1206', name: 'Urząd Skarbowy w Gorlicach' },
  { code: '1207', name: 'Pierwszy Urząd Skarbowy Kraków' },
  { code: '1208', name: 'Urząd Skarbowy Kraków-Krowodrza' },
  { code: '1209', name: 'Urząd Skarbowy Kraków-Nowa Huta' },
  { code: '1210', name: 'Urząd Skarbowy Kraków-Podgórze' },
  { code: '1211', name: 'Urząd Skarbowy Kraków-Prądnik' },
  { code: '1212', name: 'Urząd Skarbowy Kraków-Stare Miasto' },
  { code: '1213', name: 'Urząd Skarbowy Kraków-Śródmieście' },
  { code: '1214', name: 'Urząd Skarbowy w Limanowej' },
  { code: '1215', name: 'Urząd Skarbowy w Miechowie' },
  { code: '1216', name: 'Urząd Skarbowy w Myślenicach' },
  { code: '1217', name: 'Urząd Skarbowy w Nowym Sączu' },
  { code: '1218', name: 'Urząd Skarbowy w Nowym Targu' },
  { code: '1219', name: 'Urząd Skarbowy w Olkuszu' },
  { code: '1220', name: 'Urząd Skarbowy w Oświęcimiu' },
  { code: '1221', name: 'Urząd Skarbowy w Proszowicach' },
  { code: '1222', name: 'Urząd Skarbowy w Suchej Beskidzkiej' },
  { code: '1223', name: 'Pierwszy Urząd Skarbowy w Tarnowie' },
  { code: '1224', name: 'Drugi Urząd Skarbowy w Tarnowie' },
  { code: '1225', name: 'Urząd Skarbowy w Wadowicach' },
  { code: '1226', name: 'Urząd Skarbowy w Wieliczce' },
  { code: '1227', name: 'Urząd Skarbowy w Zakopanem' },
  { code: '1228', name: 'Drugi Urząd Skarbowy Kraków' },
  { code: '1402', name: 'Urząd Skarbowy w Białobrzegach' },
  { code: '1403', name: 'Urząd Skarbowy w Ciechanowie' },
  { code: '1404', name: 'Urząd Skarbowy w Garwolinie' },
  { code: '1405', name: 'Urząd Skarbowy w Gostyninie' },
  { code: '1406', name: 'Urząd Skarbowy w Grodzisku Mazowieckim' },
  { code: '1407', name: 'Urząd Skarbowy w Grójcu' },
  { code: '1408', name: 'Urząd Skarbowy w Kozienicach' },
  { code: '1409', name: 'Urząd Skarbowy w Legionowie' },
  { code: '1410', name: 'Urząd Skarbowy w Łosicach' },
  { code: '1411', name: 'Urząd Skarbowy w Makowie Mazowieckim' },
  { code: '1412', name: 'Urząd Skarbowy w Mińsku Mazowieckim' },
  { code: '1413', name: 'Urząd Skarbowy w Mławie' },
  { code: '1414', name: 'Urząd Skarbowy w Nowym Dworze Mazowieckim' },
  { code: '1415', name: 'Urząd Skarbowy w Ostrołęce' },
  { code: '1416', name: 'Urząd Skarbowy w Ostrowi Mazowieckiej' },
  { code: '1417', name: 'Urząd Skarbowy w Otwocku' },
  { code: '1418', name: 'Urząd Skarbowy w Piasecznie' },
  { code: '1419', name: 'Urząd Skarbowy w Płocku' },
  { code: '1420', name: 'Urząd Skarbowy w Płońsku' },
  { code: '1421', name: 'Urząd Skarbowy w Pruszkowie' },
  { code: '1422', name: 'Urząd Skarbowy w Przasnyszu' },
  { code: '1423', name: 'Urząd Skarbowy w Pułtusku' },
  { code: '1424', name: 'Pierwszy Urząd Skarbowy w Radomiu' },
  { code: '1425', name: 'Drugi Urząd Skarbowy w Radomiu' },
  { code: '1426', name: 'Urząd Skarbowy w Siedlcach' },
  { code: '1427', name: 'Urząd Skarbowy w Sierpcu' },
  { code: '1428', name: 'Urząd Skarbowy w Sochaczewie' },
  { code: '1429', name: 'Urząd Skarbowy w Sokołowie Podlaskim' },
  { code: '1430', name: 'Urząd Skarbowy w Szydłowcu' },
  { code: '1431', name: 'Urząd Skarbowy Warszawa-Bemowo' },
  { code: '1432', name: 'Urząd Skarbowy Warszawa-Bielany' },
  { code: '1433', name: 'Urząd Skarbowy Warszawa-Mokotów' },
  { code: '1434', name: 'Urząd Skarbowy Warszawa-Praga' },
  { code: '1435', name: 'Pierwszy Urząd Skarbowy Warszawa-Śródmieście' },
  { code: '1437', name: 'Urząd Skarbowy Warszawa-Targówek' },
  { code: '1438', name: 'Urząd Skarbowy Warszawa-Ursynów' },
  { code: '1439', name: 'Urząd Skarbowy Warszawa-Wawer' },
  { code: '1440', name: 'Urząd Skarbowy Warszawa-Wola' },
  { code: '1441', name: 'Urząd Skarbowy w Węgrowie' },
  { code: '1442', name: 'Urząd Skarbowy w Wołominie' },
  { code: '1443', name: 'Urząd Skarbowy w Wyszkowie' },
  { code: '1444', name: 'Urząd Skarbowy w Zwoleniu' },
  { code: '1445', name: 'Urząd Skarbowy w Żurominie' },
  { code: '1446', name: 'Urząd Skarbowy w Żyrardowie' },
  { code: '1447', name: 'Urząd Skarbowy w Lipsku' },
  { code: '1448', name: 'Urząd Skarbowy w Przysusze' },
  { code: '1449', name: 'Trzeci Urząd Skarbowy Warszawa-Śródmieście' },
  { code: '1602', name: 'Urząd Skarbowy w Brzegu' },
  { code: '1603', name: 'Urząd Skarbowy w Głubczycach' },
  { code: '1604', name: 'Urząd Skarbowy w Kędzierzynie-Koźlu' },
  { code: '1605', name: 'Urząd Skarbowy w Kluczborku' },
  { code: '1606', name: 'Urząd Skarbowy w Namysłowie' },
  { code: '1607', name: 'Urząd Skarbowy w Nysie' },
  { code: '1608', name: 'Urząd Skarbowy w Oleśnie' },
  { code: '1609', name: 'Pierwszy Urząd Skarbowy w Opolu' },
  { code: '1610', name: 'Drugi Urząd Skarbowy w Opolu' },
  { code: '1611', name: 'Urząd Skarbowy w Prudniku' },
  { code: '1612', name: 'Urząd Skarbowy w Strzelcach Opolskich' },
  { code: '1613', name: 'Urząd Skarbowy w Krapkowicach' },
  { code: '1802', name: 'Urząd Skarbowy w Brzozowie' },
  { code: '1803', name: 'Urząd Skarbowy w Dębicy' },
  { code: '1804', name: 'Urząd Skarbowy w Jarosławiu' },
  { code: '1805', name: 'Urząd Skarbowy w Jaśle' },
  { code: '1806', name: 'Urząd Skarbowy w Kolbuszowej' },
  { code: '1807', name: 'Urząd Skarbowy w Krośnie' },
  { code: '1808', name: 'Urząd Skarbowy w Lesku' },
  { code: '1809', name: 'Urząd Skarbowy w Leżajsku' },
  { code: '1810', name: 'Urząd Skarbowy w Lubaczowie' },
  { code: '1811', name: 'Urząd Skarbowy w Łańcucie' },
  { code: '1812', name: 'Urząd Skarbowy w Mielcu' },
  { code: '1813', name: 'Urząd Skarbowy w Przemyślu' },
  { code: '1814', name: 'Urząd Skarbowy w Przeworsku' },
  { code: '1815', name: 'Urząd Skarbowy w Ropczycach' },
  { code: '1816', name: 'Pierwszy Urząd Skarbowy w Rzeszowie' },
  { code: '1817', name: 'Urząd Skarbowy w Sanoku' },
  { code: '1818', name: 'Urząd Skarbowy w Stalowej Woli' },
  { code: '1819', name: 'Urząd Skarbowy w Strzyżowie' },
  { code: '1820', name: 'Urząd Skarbowy w Tarnobrzegu' },
  { code: '1821', name: 'Urząd Skarbowy w Ustrzykach Dolnych' },
  { code: '1822', name: 'Drugi Urząd Skarbowy w Rzeszowie' },
  { code: '1823', name: 'Urząd Skarbowy w Nisku' },
  { code: '2002', name: 'Urząd Skarbowy w Augustowie' },
  { code: '2003', name: 'Pierwszy Urząd Skarbowy w Białymstoku' },
  { code: '2004', name: 'Drugi Urząd Skarbowy w Białymstoku' },
  { code: '2005', name: 'Urząd Skarbowy w Bielsku Podlaskim' },
  { code: '2006', name: 'Urząd Skarbowy w Grajewie' },
  { code: '2007', name: 'Urząd Skarbowy w Kolnie' },
  { code: '2008', name: 'Urząd Skarbowy w Łomży' },
  { code: '2009', name: 'Urząd Skarbowy w Mońkach' },
  { code: '2010', name: 'Urząd Skarbowy w Siemiatyczach' },
  { code: '2011', name: 'Urząd Skarbowy w Sokółce' },
  { code: '2012', name: 'Urząd Skarbowy w Suwałkach' },
  { code: '2013', name: 'Urząd Skarbowy w Wysokiem Mazowieckiem' },
  { code: '2014', name: 'Urząd Skarbowy w Zambrowie' },
  { code: '2015', name: 'Urząd Skarbowy w Hajnówce' },
  { code: '2202', name: 'Urząd Skarbowy w Bytowie' },
  { code: '2203', name: 'Urząd Skarbowy w Chojnicach' },
  { code: '2204', name: 'Urząd Skarbowy w Człuchowie' },
  { code: '2205', name: 'Pierwszy Urząd Skarbowy w Gdańsku' },
  { code: '2206', name: 'Drugi Urząd Skarbowy w Gdańsku' },
  { code: '2207', name: 'Trzeci Urząd Skarbowy w Gdańsku' },
  { code: '2208', name: 'Pierwszy Urząd Skarbowy w Gdyni' },
  { code: '2209', name: 'Drugi Urząd Skarbowy w Gdyni' },
  { code: '2210', name: 'Urząd Skarbowy w Kartuzach' },
  { code: '2211', name: 'Urząd Skarbowy w Kościerzynie' },
  { code: '2212', name: 'Urząd Skarbowy w Kwidzynie' },
  { code: '2213', name: 'Urząd Skarbowy w Lęborku' },
  { code: '2214', name: 'Urząd Skarbowy w Malborku' },
  { code: '2215', name: 'Urząd Skarbowy w Pucku' },
  { code: '2216', name: 'Urząd Skarbowy w Słupsku' },
  { code: '2217', name: 'Urząd Skarbowy w Sopocie' },
  { code: '2218', name: 'Urząd Skarbowy w Starogardzie Gdańskim' },
  { code: '2219', name: 'Urząd Skarbowy w Tczewie' },
  { code: '2220', name: 'Urząd Skarbowy w Wejherowie' },
  { code: '2221', name: 'Urząd Skarbowy w Pruszczu Gdańskim' },
  { code: '2402', name: 'Urząd Skarbowy w Będzinie' },
  { code: '2403', name: 'Pierwszy Urząd Skarbowy w Bielsku-Białej' },
  { code: '2404', name: 'Drugi Urząd Skarbowy w Bielsku-Białej' },
  { code: '2405', name: 'Urząd Skarbowy w Bytomiu' },
  { code: '2406', name: 'Urząd Skarbowy w Chorzowie' },
  { code: '2407', name: 'Urząd Skarbowy w Cieszynie' },
  { code: '2408', name: 'Urząd Skarbowy w Czechowicach-Dziedzicach' },
  { code: '2409', name: 'Pierwszy Urząd Skarbowy w Częstochowie' },
  { code: '2410', name: 'Drugi Urząd Skarbowy w Częstochowie' },
  { code: '2411', name: 'Urząd Skarbowy w Dąbrowie Górniczej' },
  { code: '2412', name: 'Pierwszy Urząd Skarbowy w Gliwicach' },
  { code: '2413', name: 'Drugi Urząd Skarbowy w Gliwicach' },
  { code: '2414', name: 'Urząd Skarbowy w Jastrzębiu-Zdroju' },
  { code: '2415', name: 'Urząd Skarbowy w Jaworznie' },
  { code: '2416', name: 'Pierwszy Urząd Skarbowy w Katowicach' },
  { code: '2417', name: 'Drugi Urząd Skarbowy w Katowicach' },
  { code: '2418', name: 'Urząd Skarbowy w Kłobucku' },
  { code: '2419', name: 'Urząd Skarbowy w Lublińcu' },
  { code: '2420', name: 'Urząd Skarbowy w Mikołowie' },
  { code: '2421', name: 'Urząd Skarbowy w Mysłowicach' },
  { code: '2422', name: 'Urząd Skarbowy w Myszkowie' },
  { code: '2423', name: 'Urząd Skarbowy w Piekarach Śląskich' },
  { code: '2424', name: 'Urząd Skarbowy w Pszczynie' },
  { code: '2425', name: 'Urząd Skarbowy w Raciborzu' },
  { code: '2426', name: 'Urząd Skarbowy w Rudzie Śląskiej' },
  { code: '2427', name: 'Urząd Skarbowy w Rybniku' },
  { code: '2428', name: 'Urząd Skarbowy w Siemianowicach Śląskich' },
  { code: '2429', name: 'Urząd Skarbowy w Sosnowcu' },
  { code: '2430', name: 'Urząd Skarbowy w Tarnowskich Górach' },
  { code: '2431', name: 'Urząd Skarbowy w Tychach' },
  { code: '2432', name: 'Urząd Skarbowy w Wodzisławiu Śląskim' },
  { code: '2433', name: 'Urząd Skarbowy w Zabrzu' },
  { code: '2434', name: 'Urząd Skarbowy w Zawierciu' },
  { code: '2435', name: 'Urząd Skarbowy w Żorach' },
  { code: '2436', name: 'Urząd Skarbowy w Żywcu' },
  { code: '2602', name: 'Urząd Skarbowy w Busku-Zdroju' },
  { code: '2603', name: 'Urząd Skarbowy w Jędrzejowie' },
  { code: '2604', name: 'Pierwszy Urząd Skarbowy w Kielcach' },
  { code: '2605', name: 'Drugi Urząd Skarbowy w Kielcach' },
  { code: '2606', name: 'Urząd Skarbowy w Końskich' },
  { code: '2607', name: 'Urząd Skarbowy w Opatowie' },
  { code: '2608', name: 'Urząd Skarbowy w Ostrowcu Świętokrzyskim' },
  { code: '2609', name: 'Urząd Skarbowy w Pińczowie' },
  { code: '2610', name: 'Urząd Skarbowy w Sandomierzu' },
  { code: '2611', name: 'Urząd Skarbowy w Skarżysku-Kamiennej' },
  { code: '2612', name: 'Urząd Skarbowy w Starachowicach' },
  { code: '2613', name: 'Urząd Skarbowy w Staszowie' },
  { code: '2614', name: 'Urząd Skarbowy w Kazimierzy Wielkiej' },
  { code: '2615', name: 'Urząd Skarbowy we Włoszczowie' },
  { code: '2802', name: 'Urząd Skarbowy w Bartoszycach' },
  { code: '2803', name: 'Urząd Skarbowy w Braniewie' },
  { code: '2804', name: 'Urząd Skarbowy w Działdowie' },
  { code: '2805', name: 'Urząd Skarbowy w Elblągu' },
  { code: '2806', name: 'Urząd Skarbowy w Ełku' },
  { code: '2807', name: 'Urząd Skarbowy w Giżycku' },
  { code: '2808', name: 'Urząd Skarbowy w Iławie' },
  { code: '2809', name: 'Urząd Skarbowy w Kętrzynie' },
  { code: '2810', name: 'Urząd Skarbowy w Nidzicy' },
  { code: '2811', name: 'Urząd Skarbowy w Nowym Mieście Lubawskim' },
  { code: '2812', name: 'Urząd Skarbowy w Olecku' },
  { code: '2813', name: 'Urząd Skarbowy w Olsztynie' },
  { code: '2814', name: 'Urząd Skarbowy w Ostródzie' },
  { code: '2815', name: 'Urząd Skarbowy w Piszu' },
  { code: '2816', name: 'Urząd Skarbowy w Szczytnie' },
  { code: '3002', name: 'Urząd Skarbowy w Czarnkowie' },
  { code: '3003', name: 'Urząd Skarbowy w Gnieźnie' },
  { code: '3004', name: 'Urząd Skarbowy w Gostyniu' },
  { code: '3005', name: 'Urząd Skarbowy w Grodzisku Wielkopolskim' },
  { code: '3006', name: 'Urząd Skarbowy w Jarocinie' },
  { code: '3007', name: 'Pierwszy Urząd Skarbowy w Kaliszu' },
  { code: '3008', name: 'Drugi Urząd Skarbowy w Kaliszu' },
  { code: '3009', name: 'Urząd Skarbowy w Kępnie' },
  { code: '3010', name: 'Urząd Skarbowy w Kole' },
  { code: '3011', name: 'Urząd Skarbowy w Koninie' },
  { code: '3012', name: 'Urząd Skarbowy w Kościanie' },
  { code: '3013', name: 'Urząd Skarbowy w Krotoszynie' },
  { code: '3014', name: 'Urząd Skarbowy w Lesznie' },
  { code: '3015', name: 'Urząd Skarbowy w Międzychodzie' },
  { code: '3016', name: 'Urząd Skarbowy w Nowym Tomyślu' },
  { code: '3017', name: 'Urząd Skarbowy w Ostrowie Wielkopolskim' },
  { code: '3018', name: 'Urząd Skarbowy w Ostrzeszowie' },
  { code: '3019', name: 'Urząd Skarbowy w Pile' },
  { code: '3020', name: 'Urząd Skarbowy Poznań-Grunwald' },
  { code: '3021', name: 'Urząd Skarbowy Poznań-Jeżyce' },
  { code: '3022', name: 'Urząd Skarbowy Poznań-Nowe Miasto' },
  { code: '3023', name: 'Pierwszy Urząd Skarbowy w Poznaniu' },
  { code: '3025', name: 'Urząd Skarbowy Poznań-Winogrady' },
  { code: '3026', name: 'Urząd Skarbowy Poznań-Wilda' },
  { code: '3027', name: 'Urząd Skarbowy w Rawiczu' },
  { code: '3028', name: 'Urząd Skarbowy w Słupcy' },
  { code: '3029', name: 'Urząd Skarbowy w Szamotułach' },
  { code: '3030', name: 'Urząd Skarbowy w Śremie' },
  { code: '3031', name: 'Urząd Skarbowy w Środzie Wielkopolskiej' },
  { code: '3032', name: 'Urząd Skarbowy w Turku' },
  { code: '3033', name: 'Urząd Skarbowy w Wągrowcu' },
  { code: '3034', name: 'Urząd Skarbowy w Wolsztynie' },
  { code: '3035', name: 'Urząd Skarbowy we Wrześni' },
  { code: '3036', name: 'Urząd Skarbowy w Złotowie' },
  { code: '3037', name: 'Urząd Skarbowy w Chodzieży' },
  { code: '3038', name: 'Urząd Skarbowy w Obornikach' },
  { code: '3039', name: 'Urząd Skarbowy w Pleszewie' },
  { code: '3202', name: 'Urząd Skarbowy w Białogardzie' },
  { code: '3203', name: 'Urząd Skarbowy w Choszcznie' },
  { code: '3204', name: 'Urząd Skarbowy w Drawsku Pomorskim' },
  { code: '3205', name: 'Urząd Skarbowy w Goleniowie' },
  { code: '3206', name: 'Urząd Skarbowy w Gryficach' },
  { code: '3207', name: 'Urząd Skarbowy w Gryfinie' },
  { code: '3208', name: 'Urząd Skarbowy w Kamieniu Pomorskim' },
  { code: '3209', name: 'Urząd Skarbowy w Kołobrzegu' },
  { code: '3210', name: 'Pierwszy Urząd Skarbowy w Koszalinie' },
  { code: '3211', name: 'Drugi Urząd Skarbowy w Koszalinie' },
  { code: '3212', name: 'Urząd Skarbowy w Myśliborzu' },
  { code: '3213', name: 'Urząd Skarbowy w Pyrzycach' },
  { code: '3214', name: 'Urząd Skarbowy w Stargardzie' },
  { code: '3215', name: 'Pierwszy Urząd Skarbowy w Szczecinie' },
  { code: '3216', name: 'Drugi Urząd Skarbowy w Szczecinie' },
  { code: '3217', name: 'Trzeci Urząd Skarbowy w Szczecinie' },
  { code: '3218', name: 'Urząd Skarbowy w Szczecinku' },
  { code: '3219', name: 'Urząd Skarbowy w Świnoujściu' },
  { code: '3220', name: 'Urząd Skarbowy w Wałczu' },
]

/** Nazwa urzędu dla kodu; `null`, gdy kodu nie ma w wykazie. */
export function taxOfficeName(code: string | null | undefined): string | null {
  if (code === null || code === undefined) return null
  return TAX_OFFICES.find((office) => office.code === code)?.name ?? null
}

/**
 * Nazwa urzędu do ZAPISU w bazie: zwykłe spacje (twarda spacja powstaje przy
 * renderze przez `nbsp()`); `null`, gdy kodu nie ma w wykazie.
 */
export function taxOfficeStoredName(code: string | null | undefined): string | null {
  return taxOfficeName(code)?.replaceAll('\u00A0', ' ') ?? null
}

/** Czy tekst jest kodem urzędu z wykazu (a nie dowolnym numerem). */
export function isTaxOfficeCode(value: string | null | undefined): boolean {
  return taxOfficeName(value) !== null
}
